import { Link } from "react-router-dom";

const stats = [
  { value: "12,000+", label: "收录影视作品" },
  { value: "36", label: "细分题材分类" },
  { value: "每日", label: "更新推荐资讯" },
  { value: "0 广告", label: "纯净浏览体验" },
];

export default function AboutIntro() {
  return (
    <section className="border-y border-background-200 bg-secondary-50">
      <div className="mx-auto grid max-w-8xl grid-cols-1 gap-8 px-4 py-14 md:px-6 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-film-line"></i>
            关于金桔影院
          </span>
          <h2 className="mt-4 font-heading text-2xl font-extrabold leading-snug text-foreground-950 md:text-3xl">
            让每一次观影前，
            <br className="hidden md:block" />
            都能遇见值得的作品
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-600">
            金桔影院专注于最新电影与电视剧的推荐与介绍。我们按题材、地区、年份整理海量影视作品，提供口碑榜单与作品详情，帮你在观影前快速了解故事、阵容与看点，把宝贵的时间留给真正的好片。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/category/movie"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-movie-line"></i>
              浏览电影
            </Link>
            <Link
              to="/about"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <p className="font-heading text-2xl font-extrabold text-primary-600 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}